import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  CabType,
  FuelCapacity,
  FuelCardNumber,
  FuelType,
  RegistrationState,
  RentalCompany,
  RentalReason,
  VehicleOrganisation,
  VehicleState,
  VehicleStatus,
} from '../types/store.types';

export interface VehicleBranch {
  label: string;
  branchId: string;
}

export interface VehicleBranchInput {
  _id: string;
  name: string;
}

const initialState: VehicleState = {
  vehicleCreated: false,
  vehicleGet: false,
  rentalGet: false,
  rentalCreated: false,
  itemListGet: false,
  vehicleInfo: {},
  rentalInfo: {},
  resourceDetails: {},
  vehicleList: null,
  rentalList: [],
  branchs: [],
  companys: [],
  cabType: [],
  fuelCapacity: [],
  fuelCardNumber: [],
  fuelType: [],
  registationState: [],
  organisations: [],
  rentalCompany: [],
  rentalReasonNeeded: [],
  status: [],
  units: null,
  domain: '',
  token: null,
  vehicleStoreLoading: false,
  currentBranch: null,
  filter: {
    toggle: true,
    branch: '',
    branchId: '',
    company: '',
    companyId: '',
    date: '',
  },
};

export interface VehicleStateInput {
  cabType?: (CabType | undefined)[];
  fuelCapacity?: (FuelCapacity | undefined)[];
  fuelCardNumber?: (FuelCardNumber | undefined)[];
  fuelType?: (FuelType | undefined)[];
  registrationState?: (RegistrationState | undefined)[];
  rentalCompany?: (RentalCompany | undefined)[];
  rentalReason?: (RentalReason | undefined)[];
  status?: (VehicleStatus | undefined)[];
  organizations?: (VehicleOrganisation | undefined)[];
}

const transformBranches = (branches: VehicleBranchInput[]): VehicleBranch[] => {
  return branches.map((branch) => ({
    label: branch?.name,
    branchId: branch?._id,
  }));
};

const transformRegistrationStateData = (data: any[]) => {
  return data.map((item) => ({
    external_id: item.external_id,
    name: item.state_code,
    label: item.name,
    __typename: item.__typename,
  }));
};

export const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState,
  reducers: {
    getVehicles: (state, action) => {
      state.vehicleList = action.payload;
      state.vehicleCreated = false;
      state.vehicleGet = true;
      state.rentalGet = false;
    },
    getVehicleById: (state, action) => {
      state.vehicleInfo = action.payload;
    },
    createVehicle: (state, action) => {
      state.vehicleCreated = true;
      state.vehicleInfo = action.payload;
    },
    getRentals: (state, action) => {
      state.rentalGet = true;
      state.rentalList = action.payload;
    },
    createRental: (state, action) => {
      state.rentalInfo = action.payload;
      state.rentalCreated = true;
      state.rentalGet = false;
    },
    deleteRental: (state, action) => {
      state.rentalInfo = action.payload;
      state.rentalCreated = true;
    },
    getBranchs: (state, action) => {
      state.branchs = action?.payload;
    },
    getCompanys: (state, action: PayloadAction<VehicleBranchInput[]>) => {
      // state.companys = action.payload;
      const branchListData = transformBranches(action?.payload);
      state.companys = branchListData.sort((a, b) => a.label.localeCompare(b.label));
    },
    getListOfItems: (state, action: PayloadAction<VehicleStateInput | undefined>) => {
      state.itemListGet = true;
      state.cabType = action.payload?.cabType || [];
      state.fuelCapacity = action.payload?.fuelCapacity || [];
      state.fuelCardNumber = action.payload?.fuelCardNumber || [];
      state.fuelType = action.payload?.fuelType || [];
      // state.registationState = action.payload?.registration_state || [];
      state.registationState = action.payload?.registrationState
        ? transformRegistrationStateData(action.payload.registrationState)
        : [];
      state.rentalCompany = action.payload?.rentalCompany || [];
      state.rentalReasonNeeded = action.payload?.rentalReason || [];
      state.status = action.payload?.status || [];
      state.organisations = action.payload?.organizations || [];
    },
    getResourceDetails: (state, action) => {
      state.resourceDetails = action.payload;
    },
    updateFilter: (state, action) => {
      state.filter = action.payload;
    },
    updateVehicleData: (state, action) => {
      state.vehicleCreated = true;
      state.vehicleInfo = action.payload;
    },
    updateRentalData: (state, action) => {
      state.vehicleInfo = action.payload;
    },
    vehicleStatusUpdate: (state) => {
      state.vehicleGet = false;
    },
    unitList: (state, action) => {
      state.units = action.payload;
    },
  },
});

export const vehicleActions = vehicleSlice.actions;
export default vehicleSlice.reducer;
